import { UserRole } from '@app/types'

// Roles in decreasing permission order (left to right: most restrictive to least restrictive)
export const ALL_ROLES = [
  UserRole.STAFF,
  UserRole.ADMIN,
  UserRole.MEMBER,
  UserRole.VIEWER,
  UserRole.PUBLIC,
]

export const SLIDER_VALUES = [
  { value: 0, label: 'None', roles: [] },
  { value: 1, label: 'Staff', roles: [UserRole.STAFF] },
  { value: 2, label: 'Admin', roles: [UserRole.STAFF, UserRole.ADMIN] },
  { value: 3, label: 'Member', roles: [UserRole.STAFF, UserRole.ADMIN, UserRole.MEMBER] },
  {
    value: 4,
    label: 'Viewer',
    roles: [UserRole.STAFF, UserRole.ADMIN, UserRole.MEMBER, UserRole.VIEWER],
  },
  { value: 5, label: 'Public', roles: ALL_ROLES },
]

export const DEFAULT_ROLES = [
  {
    name: 'Admin',
    description: 'Can manage users and access.',
  },
  {
    name: 'Member',
    description: 'Can view and export results.',
  },
  {
    name: 'Viewer',
    description: 'Can view results.',
  },
]

// QUERY KEYS
export const LAYER_PERMISSIONS_QUERY_KEY = 'layer-permissions'
export const USER_CUSTOM_ROLE_QUERY_KEY = 'user-custom-role'
export const USERS_QUERY_KEY = 'admin-user-list'
export const USER_QUERY_KEY = 'userProfile'
